import React from "react"
import { useTranslation } from "react-i18next"

import FileUploderWithDragandDrop from "../../components/Common/uploader"
import templateFile from "./template/list_price_upload_template.xlsx"

const UploadListPrice = () => {
    const { t } = useTranslation()

    return (
        <>
            <div className="flex flex-col items-start gap-[16px] flex-[1_0_0] self-stretch pt-[16px]">
                <>
                    <div className="flex justify-between items-center self-stretch">
                        <label className="text-secondary-50 text-base font-bolder">
                            { t("common.uploadFile") }
                        </label>
                        <a href={ templateFile } 
                            className="text-primary-100 text-sm font-lighter underline"
                            rel="noreferrer">
                            { t("OrderMinMax.downloadSampleLabel") }
                        </a>
                    </div>
                    <div className="flex flex-col gap-[16px] w-full">
                        <div className="flex flex-col items-start gap-[24px] w-full">
                            <FileUploderWithDragandDrop
                                count={ 1 }
                                formats={ ["vnd.openxmlformats-officedocument.spreadsheetml.sheet", "xls"] }
                                uploaderLabel={ t("common.uploaderLabel") }
                                filesSupportLabel={ t("common.uploaderFileFormatLabel") }
                                module="listPriceUpload"
                            />
                        </div>
                    </div>
                </>
            </div>
        </>
    )
}

export default UploadListPrice
